import React from 'react';
import { Shield, Rocket, Building2, MonitorSmartphone, Brain } from 'lucide-react';

const HealthcareKPIs = () => {
  const reasons = [
    { icon: Shield, text: 'Enterprise-ready and secure' },
    { icon: Rocket, text: 'Fast deployment and high adoption' },
    { icon: Building2, text: 'Built for distributed teams' },
    { icon: MonitorSmartphone, text: 'Supports in-person, hybrid, and virtual care' },
    { icon: Brain, text: 'Improves communication without replacing human judgment' }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-cyan-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Why Healthcare Leaders Choose <span className="text-cyan-400">Traain</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className={`p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-cyan-900/20 border border-cyan-500/30 hover:border-cyan-400/60 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 ${
                  index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''
                }`}
              >
                <Icon className="w-10 h-10 text-cyan-400 mb-4" />
                <p className="text-lg text-gray-300">{reason.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HealthcareKPIs;
